import { h } from '@debbie/cortex/dist/index.js';
import { useKeyById } from '@debbie/cortex/dist/keys/index.js';
import React from 'react';
import { Link } from 'react-router-dom';
import { load } from '../connect/utils.js';
import Errors from '../Errors.js';
const KeyPreview = (props) => {
    const preview = useKeyById(props.id);
    return (React.createElement("div", null,
        h.isError(preview) ? React.createElement(Errors, { errors: [preview.error.message] }) : null,
        load({ preview }, ({ preview }) => {
            return React.createElement(Link, { to: `/developers` }, preview.name);
        }, 'loading')));
};
export default KeyPreview;
//# sourceMappingURL=KeyPreview.js.map